import { render, staticRenderFns } from "./IconBackwardArrowRounded.vue?vue&type=template&id=227a6f75"
import script from "./IconBackwardArrowRounded.vue?vue&type=script&lang=js"
export * from "./IconBackwardArrowRounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports